import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Input} from 'reactstrap'

class FilterSecteur extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    secteurs: PropTypes.array,
  }

  static defaultProps = {
    secteurs: [],
  }

  onChange = (event) => {
    const value = event.target.value
    this.props.onChange({
      secteur: value === '' ? null : parseInt(value, 10)
    })
  }

  render() {
    const {secteurs, value} = this.props
    const selected = (value === undefined || value === null || isNaN(value))
      ? ''
      : parseInt(value, 10)

    return (
      <Input type="select" value={selected} onChange={this.onChange}>
        <option value="">Choisissez un secteur</option>
        {secteurs.map((secteur) => (
          <option value={secteur.value} key={secteur.value}>{secteur.label}</option>
        ))}
      </Input>
    )
  }
}

export default connect(
  (state) => ({
    secteurs: state.secteurs.secteurs.map(secteur => ({
      value: secteur.id,
      label: secteur.name
    }))
  })
)(FilterSecteur)
